import axios from '@/utils/request'
import base from './base'
import qs from 'qs';

export function getAllModules() {
  return axios.get(`${base.url}/auth/loginUser/findAll`)
}

export function getModules(id) {
  return axios.get(`${base.url}/auth/loginUser/findAll?companyId=` + `${id}`)
}

export function getCompangModules(id) {
  return axios.get(`${base.url}/auth/loginUser/findAll?userId=` + `${id}`)
}

export function login(data) {
  return axios.post(`${base.url}/auth/loginUser/login`, qs.stringify(data));
}

export function checkLogin(data) {
  return axios.post(`${base.url}/auth/loginUser/checkLogin`, qs.stringify(data));
}

export function getInfo(token) {
  return axios.post(`${base.url}/auth/loginUser/userInfo`, qs.stringify(token));
}

export function permission(type) {
  return axios.get(`${base.url}/auth/menus/getMenus?type=` + `${type}`);
}

export function logout() {
  return axios.get(`${base.url}/auth/loginUser/logout`);
}

export function updatePassWord(data) {
  return axios.post(`${base.url}/auth/user/updPwd`, qs.stringify(data));
}

export function twoFA(data) {
  return axios.post(
`${base.url}/auth/loginUser/twoFA`
    , qs.stringify(data));
}

export function verifyOtp(data) {
  return axios.post(
`${base.url}/auth/loginUser/verifyOtp`
    , qs.stringify(data));
}

export function sendOtp(data) {
  return axios.post(
`${base.url}/auth/loginUser/sendOtp`
    , qs.stringify(data));
}

export function userAddEmail(data) {
  return axios.post(
`${base.url}/auth/loginUser/userAddEmail`
    , qs.stringify(data))
}

export function verifyPassword(data) {
  return axios.post(
`${base.url}/auth/loginUser/verifyPassword`
    , qs.stringify(data))
}
